import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core'; // Removido Input/Output
import { ViewModeService, ViewMode } from '@/services/view-mode.service'; // Ajuste o caminho conforme seu projeto

@Component({
  selector: 'app-view-toggle',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex items-center gap-1 bg-white border border-gray-200 rounded-lg p-1 hidden md:flex">
      <button
        (click)="setMode('grid')"
        [class.bg-[#4A90E2]]="viewMode() === 'grid'"
        [class.text-white]="viewMode() === 'grid'"
        [class.text-gray-600]="viewMode() !== 'grid'"
        class="p-2 rounded-md transition-colors hover:bg-gray-50 flex items-center justify-center"
        title="Visualização em grade"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <rect x="3" y="3" width="7" height="7" rx="1" stroke-width="2"/>
          <rect x="14" y="3" width="7" height="7" rx="1" stroke-width="2"/>
          <rect x="3" y="14" width="7" height="7" rx="1" stroke-width="2"/>
          <rect x="14" y="14" width="7" height="7" rx="1" stroke-width="2"/>
        </svg>
      </button>
      
      <button
        (click)="setMode('list')"
        [disabled]="isMobile()"
        [class.opacity-50]="isMobile()"
        [class.cursor-not-allowed]="isMobile()"
        [class.bg-[#4A90E2]]="viewMode() === 'list'"
        [class.text-white]="viewMode() === 'list'"
        [class.text-gray-600]="viewMode() !== 'list'"
        class="p-2 rounded-md transition-colors hover:bg-gray-50 flex items-center justify-center"
        [title]="isMobile() ? 'Disponível apenas em telas maiores' : 'Visualização em lista'"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <line x1="3" y1="6" x2="21" y2="6" stroke-width="2" stroke-linecap="round"/>
          <line x1="3" y1="12" x2="21" y2="12" stroke-width="2" stroke-linecap="round"/>
          <line x1="3" y1="18" x2="21" y2="18" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  `,
})
export class ViewToggleComponent {
  private viewModeService = inject(ViewModeService);

  // Getters para usar no template
  viewMode = this.viewModeService.viewMode;
  isMobile = this.viewModeService.isMobile;

  setMode(mode: ViewMode): void {
    this.viewModeService.setMode(mode);
  }
}